import './Preloader.scss';

export const Preloader = ({ isActive }: { isActive: boolean }) => {
  return (
    <div className={`preloader ${isActive ? 'active' : ''}`}>
      <div className="spinner"></div>
    </div>
  );
};